import Button from "../General/Button";
import { handleAuthModal, logout } from "../../store/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import { useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";

function HeroSection() {
	const dispatch = useDispatch();
	const { user } = useSelector((state : any) => state.auth);
	const [showDrawer, setShowDrawer] = useState(false);
	const router = useRouter();

	// Handle Auth Modal
    const openDialog = (ID = null) => {	
        dispatch(handleAuthModal(true));

        // if(ID) 
        //     dispatch(setRedirectTo(`deals/${ID}`));
    }

	return (
		<div className="--align mt-5 lg:h-[80vh]">
			<div className="flex justify-between items-center">
				<div className="w-[50%] md:w-[30%] lg:w-[190px]">
					<img src="/logo.png" alt="" />
				</div>
				{
					user.isLoggedIn ?
					<div>
						<div className={`flex items-center`}>
							<p className="text-theme-green font-semibold mr-4 hidden md:block">Hi, {user.name || 'User'}</p>
							<Link href={`/dashboard`} className ="font-semibold 
								bg-theme-green
								text-white
								rounded
								mr-5 
								py-2 
								px-2 								
								transition
								duration-200">
								Dashboard
							</Link>
						</div>
					</div>
					:
					<Button onClick={() => dispatch(handleAuthModal(true))} styles = 'bg-theme-green text-white px-6 h-[45px]' borderRadius = {39}> 
						Start Selling 
					</Button>
				}
			</div>

			<div className="flex flex-col-reverse mt-10 md:flex-row md:justify-between md:items-center">
				<div className="mt-10 md:w-[40%] lg:w-[50%]">
					<h1 className="text-theme-blue text-3xl font-semibold lg:mb-4 lg:text-4xl">Sell APIs, Excipients & </h1>
					<h1 className="text-theme-blue text-3xl font-semibold lg:mb-4 lg:text-4xl">Nutraceuticals To Small and Medium</h1>
					<h1 className="text-theme-blue text-3xl font-semibold lg:text-4xl">Sized Formulators Globally</h1>

					{
						!user.isLoggedIn &&
						<Button onClick={() => dispatch(handleAuthModal(true))} styles = 'bg-theme-green text-white px-6 mt-5 lg:mt-10 h-[45px]' borderRadius = {39}> 
							Start Selling 
						</Button>
					}
				</div>

				<div className="md:w-[55%] lg:w-[45%] lg:h-[65vh]">
					<img className="w-full h-full" src="/SellerHome/HeroImage.png" alt="" />
				</div>
			</div>
		</div>
	)
}

export default HeroSection